var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
      },
    },
    [
      _c("g", { attrs: { transform: "translate(-10683 9180)" } }, [
        _c("g", { attrs: { transform: "translate(10062 -11147)" } }, [
          _c(
            "g",
            {
              attrs: {
                transform: "translate(621 1967)",
                fill: "#fff",
                stroke: "#1b1b1b",
                "stroke-width": "1.5",
              },
            },
            [
              _c("circle", {
                attrs: { cx: "16", cy: "16", r: "16", stroke: "none" },
              }),
              _c("circle", {
                attrs: { cx: "16", cy: "16", r: "15.25", fill: "none" },
              }),
            ]
          ),
        ]),
        _c("rect", {
          attrs: {
            width: "4",
            height: "14",
            rx: "1",
            transform: "translate(10706 -9166) rotate(90)",
            fill: "#ffde01",
          },
        }),
        _c(
          "g",
          { attrs: { transform: "translate(20613 -18195)", fill: "#ffde01" } },
          [
            _c("path", {
              attrs: {
                d: "M -9908 9032.5 L -9920 9032.5 C -9920.275390625 9032.5 -9920.5 9032.275390625 -9920.5 9032 L -9920.5 9030 C -9920.5 9029.724609375 -9920.275390625 9029.5 -9920 9029.5 L -9908 9029.5 C -9907.724609375 9029.5 -9907.5 9029.724609375 -9907.5 9030 L -9907.5 9032 C -9907.5 9032.275390625 -9907.724609375 9032.5 -9908 9032.5 Z",
                stroke: "none",
              },
            }),
            _c("path", {
              attrs: {
                d: "M -9920 9030 L -9920 9032 L -9908 9032 L -9908 9030 L -9920 9030 M -9920 9029 L -9908 9029 C -9907.447265625 9029 -9907 9029.447265625 -9907 9030 L -9907 9032 C -9907 9032.552734375 -9907.447265625 9033 -9908 9033 L -9920 9033 C -9920.552734375 9033 -9921 9032.552734375 -9921 9032 L -9921 9030 C -9921 9029.447265625 -9920.552734375 9029 -9920 9029 Z",
                stroke: "none",
                fill: "#1b1b1b",
              },
            }),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }